export default __webpack_public_path__ + "static/media/MollierEnthalpy.77993b76.svg";